"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MessageSquareOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 2.5v9.185c.402-.28.83-.574 1.248-.846a15.79 15.79 0 011.387-.825c.22-.113.458-.221.695-.304a2.7 2.7 0 01.884-.166H14.5V2.5h-13zM1.143 1C.512 1 0 1.5 0 2.116v11.16c0 .616.472.926.993.58.307-.204.66-.45 1.035-.712 1.367-.951 3.017-2.1 3.686-2.1h9.143c.631 0 1.143-.5 1.143-1.116V2.116C16 1.5 15.488 1 14.857 1H1.143z",
    clipRule: "evenodd"
  })))
});
MessageSquareOutlineIcon.displayName = 'MessageSquareOutlineIcon';
var _default = exports.default = MessageSquareOutlineIcon;